export var AUTH_ROLE = /*#__PURE__*/function (AUTH_ROLE) {
  AUTH_ROLE[AUTH_ROLE["noPrivilege"] = 0] = "noPrivilege";
  AUTH_ROLE[AUTH_ROLE["reader"] = 1] = "reader";
  AUTH_ROLE[AUTH_ROLE["editor"] = 2] = "editor";
  AUTH_ROLE[AUTH_ROLE["filler"] = 3] = "filler";
  AUTH_ROLE[AUTH_ROLE["executor"] = 4] = "executor";
  AUTH_ROLE[AUTH_ROLE["externUser"] = 10] = "externUser";
  AUTH_ROLE[AUTH_ROLE["administrator"] = 1024] = "administrator";
  AUTH_ROLE[AUTH_ROLE["owner"] = 2048] = "owner";
  return AUTH_ROLE;
}({}); // 拥有者（概念有点模糊，具体咨询seedzhang）
//# sourceMappingURL=const.js.map